'use strict';
module.exports = class BuildContext {
  // get isPrerender () {
  //   throw new Error('abstract implementation');
  // }
  // get appName () {
  //   throw new Error('abstract implementation');
  // }

  // get entryName () {
  //   throw new Error('abstract implementation');
  // }

  // get debug () {
  //   throw new Error('abstract implementation');
  // }

  // get useLongCaches () {
  //   throw new Error('abstract implementation');
  // }

  // get useLiveSafetyFeatures () {
  //   throw new Error('abstract implementation');
  // }

  // get defaultLocale () {
  //   throw new Error('abstract implementation');
  // }

  // get defaultRegion () {
  //   throw new Error('abstract implementation');
  // }

  // get contentRoot () {
  //   throw new Error('abstract implementation');
  // }
  //
  // get contentRegistry () {
  //   throw new Error('abstract implementation');
  // }


  // async contentForView (contentMetaIndex, view, params) {
  //   throw new Error('abstract implementation');
  // }
  // async loadViewFn (viewName) {
  //   throw new Error('abstract implementation');
  // }

  // async ensureContentMetaIndexFor (existingIndex, view, params) {
  //   throw new Error('abstract implementation');
  // }

  // async loadMessages (view, params) {
  //   throw new Error('abstract implementation');
  // }

  // get reduxStore () {
  //   throw new Error('abstract implementation');
  // }

  // get routeDefinitions () {
  //   return new Error('abstract implementation');
  // }

  // get regions () {
  //   return new Error('abstract implementation');
  // }

  // get locales () {
  //   return new Error('abstract implementation');
  // }

};


/**
 * @typedef {ContentMetaIndex}
 * @type {Object.<string, {t: number, c: string}>}
 *
 * Minified representation of the full content meta index used by the build
 * system. Each content paths maps only to a property `c` for the checksum
 * and an optional property `t` whose values can only ever be `1` if present
 * to identify translatable content.
 */



// WEBPACK FOOTER //
// ./lib/rlink-router/BuildContext.js